/* eslint-disable max-len */
export const DOWNLOAD_ERROR_MESSAGE = 'We are unable to download your document.\nPlease try again later or call customer service.';
